<div class="buttons" [ngClass]="flexColumn ? 'column' : ''">
	<a href="https://hintclearcals.app.link/f6xbuHgT3wb" target="_blank" rel="noopener noreferrer">
		<img
			src="{{ appStoreImgUrl }}"
			alt="app store button"
			height="{{ imgDimension.height }}"
			width="{{ imgDimension.width }}"
			[ngStyle]="storeStyle"
		/>
		<ul class="rating">
			<li *ngFor="let star of storeData.appStoreRatingFloor">
				<ic-icon [icon]="starIcon" class="checked"></ic-icon>
			</li>
			<li *ngIf="storeData.appStoreRatingDecimal">
				<ic-icon [icon]="starHalfIcon" class="checked"></ic-icon>
			</li>
			<span>141</span>
		</ul>
	</a>
	<a href="https://hintclearcals.app.link/NBgy2ToT3wb" target="_blank" rel="noopener noreferrer">
		<img
			src="{{ playStoreImgUrl }}"
			class="google-play"
			alt="play store button"
			height="{{ imgDimension.height }}"
			width="{{ imgDimension.width }}"
			[ngStyle]="storeStyle"
		/>
		<ul class="rating">
			<li *ngFor="let star of storeData.playStoreRatingFloor">
				<ic-icon [icon]="starIcon" class="checked"></ic-icon>
			</li>
			<li *ngIf="storeData.playStoreRatingDecimal">
				<ic-icon [icon]="starHalfIcon" class="checked"></ic-icon>
			</li>
			<span>527</span>
		</ul>
	</a>
</div>
